const track = (type, params) => {
    if (!window.bigTj || typeof window.bigTj.track !== 'function') return;

    window.bigTj.track(type, params);
};

export const shoppingUbsidyTipShowTrack = ({ abTestIsBValue, tjData }) => {
    track('show', {
        obj_id: 'shopping_ubsidy_tip',
        obj_type: 'recharge_detail',
        ab_test_json: {
            bwbtAllowance: abTestIsBValue,
        },
        ...tjData,
    });
};

export const shoppingUbsidyTipClickTrack = ({ abTestIsBValue, tjData }) => {
    track('click', {
        obj_id: 'shopping_ubsidy_tip',
        obj_type: 'recharge_detail',
        ab_test_json: {
            bwbtAllowance: abTestIsBValue,
        },
        ...tjData,
    });
};
